import React, { useState, useEffect } from 'react';
import useExploreStore from '../../contexts/useExploreStore';

const CommandBar = () => {
  const { currentQuery, setCurrentQuery, addToHistory, setShowStarterPanel } = useExploreStore();

  const [input, setInput] = useState('');

  useEffect(() => {
    setInput(currentQuery); // Update input when currentQuery changes
  }, [currentQuery]);

  const handleSubmit = () => {
    if (input.trim()) {
      setCurrentQuery(input);
      setShowStarterPanel(false);

      // Add the query to history, storing the full entry
      addToHistory({ query: input });

      // Clear input field after submission
      setInput('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="p-4 bg-gray-300 flex items-center w-full">
      <input
        type="text"
        className="flex-grow p-2 border border-gray-400 rounded-l focus:outline-none"
        placeholder="Holodeck Command..."
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button
        className="p-2 bg-blue-500 text-white rounded-r hover:bg-blue-600 focus:outline-none"
        onClick={handleSubmit}
      >
        Submit
      </button>
    </div>
  );
};

export default CommandBar;
